import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "accordion-item" }
const _hoisted_2 = { class: "accordion-header px-3 d-flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", {
  class: "fs-4 fw-bold mb-0 ms-4 py-6 w-50 w-md-100",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#review_body"
}, "Proposal review", -1)
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  class: "accordion-icon ms-5",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#review_body"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2x" }
const _hoisted_7 = {
  id: `review_body`,
  class: "accordion-collapse collapse",
  "aria-labelledby": "review_body",
  "data-bs-parent": "#copy_accordion"
}
const _hoisted_8 = { class: "accordion-body" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Authorization"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Action"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px" }, "Data")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-bolder" }, "Account:", -1)
const _hoisted_13 = { class: "mt-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-bolder" }, "Permission:", -1)
const _hoisted_15 = { class: "text-hover-info ms-2" }
const _hoisted_16 = { class: "d-flex flex-column align-items-start" }
const _hoisted_17 = { class: "fs-7 badge badge-light-primary border-dashed border-1 border-primary m-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  style: {"vertical-align":"top"}
                }, [
                  _createElementVNode("td", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(action.authorization, (auth, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "d-flex flex-column align-items-start border border-1 border-grey-400 rounded my-1 p-2",
                        style: {"width":"fit-content"}
                      }, [
                        _createElementVNode("div", null, [
                          _hoisted_12,
                          _createVNode(_component_router_link, {
                            to: `/account/${auth.actor}`,
                            class: "text-hover-info fs-6 ms-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(auth.actor), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("span", _hoisted_15, _toDisplayString(auth.permission), 1)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_router_link, {
                        to: `/account/${action.account}`,
                        class: "fs-7 badge badge-light-info border-dashed border-1 border-info m-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(action.account), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(action.name), 1)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(action.data, (data, key) => {
                      return (_openBlock(), _createElementBlock("div", { key: key }, _toDisplayString(key) + " : " + _toDisplayString(data), 1))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}